import Vue from 'vue'
import Vuex from 'vuex'
import agent from './agent'
import auth from './auth'
import resources from './resources'
import observation from './observation'
import { SET_ROLE } from './mutation-types'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const mutations = {
  [SET_ROLE] (state, role) {
    state.role = role
  }
}

const getters = {
  roles: (state) => state.roles,
  selectedRoleName: (state) => state.roles[state.role],
  selectedRole: (state) => state.role,
  agentCategoryLabel: (state) => (key) => agentCategoryEnum[key] ? agentCategoryEnum[key] : key
}

export const rolesEnum = Object.freeze({
  FIRST_RESPONDER: 0,
  DECON_OR_SAMPLER: 1
})

export const agentTypeEnum = Object.freeze({
  BAgent: 'BAgent',
  CAgent: 'CAgent',
  RNAgent: 'RNAgent',
  BioMarker: 'BioMarker',
})

export const agentCategoryEnum = Object.freeze({
  NERVE: 'Nerve agent',
  BLISTER: 'Blister agent',
  BLOOD: 'Blood agent',
  SUFFOCATING: 'Suffocating agent',
  RIOT_CONTROL: 'Riot Control agent',
  PSYCHOTOMIMETIC: 'Psychotomimetic agent',
  INCAPACITATING: 'Incapacitating agent',
  PESTICIDE: 'Pesticide',
  TOXIC: 'Toxic Industrial Chemical TIC',
  BACTERIA: 'Bacteria',
  VIRUS: 'Virus',
  TOXIN: 'Toxin',
  RADIOLOGICAL: 'Radiological agent',
  NUCLEAR: 'Nuclear agent',
  BIOMARKER: 'Biomarker'
})

export default new Vuex.Store({
  modules: {
    auth,
    agent,
    resources,
    observation,
  },
  state: {
    roles: ['First responder', 'Laypeople'],
    role: rolesEnum.FIRST_RESPONDER,
  },
  mutations,
  getters,
  strict: debug
})
